<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
             

            <div class="vx-col hidden lg:block lg:w-1/2 p-4  mx-auto self-center">
              <img :src="getLogoUrl" alt="login" class="mx-auto" width="53%" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Vendor Registration</h4>
                  <p>Fill the below form to create a new account.</p>
                </div>
                <register-jwt></register-jwt>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import RegisterJwt from "./RegisterJWT.vue";
import RegisterFirebase from "./RegisterFirebase.vue";
import RegisterAuth0 from "./RegisterAuth0.vue";
import axios from "@/axios.js";
export default {
  components: {
    RegisterJwt,
    RegisterFirebase,
    RegisterAuth0,
  },
    data() {
    return { 
      getLogoUrl: "",
    };
  },
   computed: { 
    getLogo() {
      axios({
        method: "get",
        url: "getLogo",
      })
        .then((response) => {
          console.log("response:", response["data"]);
          this.getLogoUrl = response["data"];
        })
        .catch((error) => {
          this.decodeErrorFromAxios(error);
        });
    },
  },
   mounted() {
    this.getLogo;
  },
};
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
